<template>
  <div class="container p-4">
    <card>
      <div class="row">
        <div v-if="id_type_status == 1" class="col-md-12">
          <h5>
            Estado de postulación:
            <strong style="color: blue">Pendiente</strong>
          </h5>
        </div>
        <div v-else-if="id_type_status == 2" class="col-md-12">
          <h5>
            Estado de postulación: <strong style="color: red">Rechazado</strong>
          </h5>
        </div>
        <div v-else-if="id_type_status == 3" class="col-md-12">
          <h5>
            Estado de postulación:
            <strong style="color: green">Aprobado</strong>
          </h5>
          <br />
          <h5 v-if="id_type_status_payment == 0">
            Pago: <strong>Pendiente</strong>
          </h5>
          <h5 v-if="id_type_status_payment == 1">
            Pago: <strong>Pendiente</strong>
          </h5>
          <h5 v-if="id_type_status_payment == 2">
            Pago: <strong>Rechazado</strong>
          </h5>
          <h5 v-if="id_type_status_payment == 3">
            Pago: <strong>Aprobado</strong>
          </h5>
          <h5 v-if="id_type_status_payment == 4">
            Pago: <strong>Incompleto</strong>
          </h5>
        </div>
        <div class="col-md-12">
          <h7
            v-if="
              form_update.autoapproved == 1 ||
              form_update.amount == 0 ||
              !form_update.amount
            "
            ><strong>Inversión: </strong>Gratuito</h7
          >
          <h7 v-else><strong>Inversión: </strong>${{ form_update.amount }}</h7>
        </div>
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-sm bg-gradient-fvf float-right"
            @click.prevent="returnUrl"
          >
            Volver
          </button>
        </div>

        <div class="col-md-12">
          <template>
            <div>
              <img
                v-if="!isLoading && isBanner"
                :src="form_update.url_banner"
                alt="banner"
                class="image-fluid"
                style="width: 100%; height: 300px; object-fit: cover"
              />
              <div v-else class="loader">
                <i class="loader-icon"></i>
              </div>
            </div>
          </template>
          <h4 slot="header" class="card-title mt-4">{{ form_update.name }}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ms-4 me-4">
          <p class="text-justify">{{ form_update.description }}</p>
        </div>
        <div class="col-md-12 text-center float-right">
          <button
            v-if="id_type_status == 0 && form_update.autoapproved == 0"
            type="submit"
            class="btn bg-gradient-fvf mt-3"
            @click.prevent="openUploadElement"
          >
            Postularme
          </button>
          <button
            v-if="id_type_status == 1"
            type="submit"
            class="btn bg-gradient-fvf mt-3"
            @click.prevent="openUploadElement"
          >
            Actualizar archivos
          </button>
          <button
            v-if="id_type_status == 2"
            type="submit"
            class="btn bg-gradient-fvf mt-3"
            @click.prevent="openUploadElement"
          >
            Corregir postulación
          </button>
          <button
            v-if="id_type_status == 0 && form_update.autoapproved == 1"
            type="submit"
            class="btn bg-gradient-fvf mt-3"
            @click.prevent="postulateMe"
          >
            Postularme
          </button>
          <button
            v-if="id_type_status == 3 && id_type_status_payment != 3"
            type="submit"
            class="btn bg-gradient-fvf mt-3"
            @click.prevent="openModalPayment"
          >
            Reportar pago
          </button>
          <buttom
            v-if="id_type_status == 3 && id_type_status_payment == 3 && form_update.params == 'PizarraDT'"
            type="submit"
            class="btn bg-gradient-fvf mt-3"
            @click.prevent="pizarraDT"
          >
            Acceder
          </buttom>
          <a
            v-else-if="id_type_status == 3 && id_type_status_payment == 3 && form_update.params != 'PizarraDT'"
            type="submit"
            class="btn bg-gradient-fvf mt-3"
            :href="
              form_update.url.startsWith('http://') ||
              form_update.url.startsWith('https://')
                ? form_update.url
                : 'https://' + form_update.url
            "
            target="_blank"
          >
            Acceder
          </a>
        </div>
      </div>
      <!-- MODAL UPLOAD IMAGE -->
      <div
        class="modal fade"
        :id="'modalPostulation'"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <strong>Requisitos</strong>
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click.prevent="closeUploadElement"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="row">
                  <div class="col-md-6">
                    <p>{{ form_update.requires }}</p>
                  </div>
                </div>
                <div class="row" v-if="filesUser && filesUser.length > 0">
                  <div class="col-md-12">
                    <h6><u>Tus archivos</u></h6>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="
                    (id_type_status == 1 &&
                      filesUser &&
                      filesUser.length > 0) ||
                    (id_type_status == 2 && filesUser && filesUser.length > 0)
                  "
                  v-for="item in filesUser"
                >
                  <div class="col-md-10 me-0">
                    <a :href="item.url_file" target="_blank">{{ item.name }}</a>
                  </div>
                  <div class="col-md-2">
                    <button
                      type="submit"
                      class="btn btn-sm bg-gradient-fvf-switch"
                      style="
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
                      "
                      @click.prevent="deleteFile(item.id)"
                    >
                      <v-icon name="trash" fill="#CE0D0D" size="20px"></v-icon>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <file-pond
                          ref="filePond"
                          name="image"
                          v-model="form_save.url_file"
                          allow-multiple="true"
                          class="w-100 h-100"
                          label-idle="Arrastre o seleccione los archivos"
                        ></file-pond>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button
                        v-if="id_type_status == 0"
                        type="submit"
                        class="btn btn-sm btn-info btn-fill float-right"
                        @click.prevent="postulateWithRequires"
                      >
                        Subir
                      </button>
                      <button
                        v-if="id_type_status == 1 || id_type_status == 2"
                        type="submit"
                        class="btn btn-sm btn-info btn-fill float-right"
                        @click.prevent="uploadFiles"
                      >
                        Subir
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- MODAL PAYMENT REPORT -->
      <div
        :class="
          selectorOpen ? 'modal fade show disable-scroll' : 'modal fade show'
        "
        :id="'modalPayment'"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <strong>Nuevo pago</strong>
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click.prevent="closePaymentElement"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <h8><strong>Curso: </strong> {{ form_update.name }}</h8>
                  </div>
                  <div class="col-md-12">
                    <h8
                      ><strong>Monto de inversión: </strong> ${{
                        form_update.amount
                      }}</h8
                    >
                  </div>
                  <div class="col-md-12">
                    <h8><strong>Tasa BCV: </strong> Bs.{{ bcvRate.value }}</h8>
                  </div>
                  <div class="col-md-12">
                    <h8
                      ><strong>Total a pagar: </strong> Bs.{{
                        totalPaymentAmount
                      }}</h8
                    >
                  </div>
                  <div class="col-md-12">
                    <hr size="8px" color="black" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <label>Banco de destino</label>
                    <multiselect
                      v-model="form_payment.id_company_bank"
                      label="name_bank"
                      class="custom-rounded-multiselect text-capitalize"
                      :options="companyBank"
                      selectLabel="Click/enter para elegir"
                      selectedLabel="Seleccionado"
                      deselectLabel="Click/Enter para remover"
                      :searchable="true"
                      :placeholder="'Seleccione el Banco de destino'"
                      placeholder-class="custom-placeholder"
                    ></multiselect>
                  </div>
                </div>
                <div class="row mt-2" v-if="form_payment.id_company_bank">
                  <div class="col-md-12">
                    <hr size="8px" color="black" />
                  </div>
                  <div class="col-md-12">
                    <p>
                      <strong>Datos para el pago:</strong>
                    </p>
                  </div>
                  <div class="col-md-12">
                    <p>
                      <strong>Teléfono :</strong>
                      {{ form_payment.id_company_bank.phone }}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <p>
                      <strong>CI/RIF:</strong>
                      {{ form_payment.id_company_bank.dni }}
                    </p>
                  </div>
                </div>
                <div class="row" v-if="form_payment.id_company_bank">
                  <div class="col-md-12">
                    <hr size="8px" color="black" />
                  </div>
                  <div class="col-md-12">
                    <base-input
                      type="text"
                      label="Banco emisor"
                      placeholder="Indica el banco emisor"
                      v-model="form_payment.origin_bank"
                    >
                    </base-input>
                  </div>
                  <div class="col-md-12">
                    <label>Fecha de pago</label>
                    <date-picker
                      class="form-control align-content-center d-flex"
                      style="width: 100%; height: 50%; flex-wrap: wrap"
                      v-model="form_payment.date"
                      :format="'DD/MM/YYYY'"
                      placeholder="Selecciona una fecha"
                      popupPlacement="top"
                      @open="handleOpenChange"
                      @close="handleCloseChange"
                      :disabled-date="disableFutureDates"
                    ></date-picker>
                  </div>
                  <div class="col-md-12">
                    <base-input
                      type="number"
                      label="Teléfono"
                      placeholder="Indica el teléfono del banco emisor"
                      v-model="form_payment.phone"
                    >
                    </base-input>
                  </div>
                  <div class="col-md-12">
                    <base-input
                      type="text"
                      label="Monto pagado"
                      placeholder="Indica el monto pagado"
                      v-model="amountWithPrefix"
                    >
                    </base-input>
                  </div>

                  <div class="col-md-12">
                    <base-input
                      type="text"
                      label="Referencia"
                      placeholder="Indica la referencia del pago"
                      v-model="form_payment.reference"
                    >
                    </base-input>
                  </div>
                </div>
                <div class="row" v-if="form_payment.id_company_bank">
                  <div class="col-md-12">
                    <label>Captura del pago</label>
                    <file-pond
                      ref="filePondPayment"
                      name="capture"
                      v-model="form_payment.url_image"
                      allow-multiple="true"
                      class="w-100 h-100"
                      label-idle="Arrastre o seleccione la captura del pago"
                    ></file-pond>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <div class="text-center">
                      <button
                        v-if="form_payment.id_company_bank"
                        type="submit"
                        class="btn btn-sm btn-info btn-fill float-right"
                        @click.prevent="savePayment"
                      >
                        Guardar
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </card>
  </div>
</template>
<script>
import Card from "src/components/Cards/Card.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import es from "vue2-datepicker/locale/es";
import LTable from "src/components/Table.vue";
import moment from "moment";
import LoadImage from "../../../public/img/load_img.jpg";
import ObservationChat from "src/components/ObservationChat.vue";
import Cookies from "js-cookie";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    Card,
    Multiselect,
    FilePond,
    DatePicker,
    LTable,
    ObservationChat,
  },
  data() {
    return {
      window_title: "Ficha del club",
      button_label: "Actualizar información",
      locale: { lang: "es", weekDays: ["L", "M", "M", "J", "V", "S", "D"] },
      loading: true,

      id_user_logged: Cookies.get("id"),
      id_type_status: "",
      id_type_status_payment: "",
      id_user_platform: "",

      filesUser: [],
      selectorOpen: false,
      bcvRate: {},
      companyBank: [],
      totalPaymentAmount: 0,
      amountWithDecimals: 0,
      idTmp: 0,
      listVisible: false,
      deleting: false,
      loaded: false,
      modalActiveUpdate: false,

      user_data: {
        id: 0,
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
        country: "",
      },

      form_payment: {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
      },

      form_save: {
        id_user_platform: "",
        name: "",
        url_file: "",
      },

      form_update: {
        id: 0,
        name: "",
        url: "",
        url_banner: "",
        url_image: "",
        description: "",
        autoapproved: "",
        params: "",
        amount: "",
        requires: "",
      },
    };
  },
  mounted() {
    this.getElement(this.$route.params.id);
    this.getStatus();
    this.loadImage();

    DatePicker.locale("es", es);
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },

    isLoading() {
      if (this.loading) {
        return true;
      } else {
        return false;
      }
    },
    isBanner() {
      if (
        this.form_update.url_banner == "" ||
        this.form_update.url_banner == null ||
        this.form_update.url_banner == undefined
      ) {
        console.log("No hay imagen");
        return false;
      } else {
        console.log("Hay imagen");
        return true;
      }
    },
    amountWithPrefix: {
      get() {
        return `Bs. ${(this.form_payment.amount / 100).toLocaleString("es-VE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
      set(newValue) {
        const value = newValue.replace(/[^0-9]/g, ""); // Remove all non-numeric characters
        this.form_payment.amount = value;
        this.amountWithDecimals = parseFloat(value / 100).toFixed(2);
        console.log(this.amountWithDecimals);
      },
    },
    // rows() {
    //   return this.UsersTmp.length;
    // },
  },
  methods: {
    ...mapActions(["getData", "updateData", "changeStatusData", "createData", "UserCreateDT"]),

    pizarraDT(){
      let form = {
        url: "user/user/myprofile",
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.user_data = response.data;
            this.newUserDT();
          }
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
          alert("Ocurrió un error, intente más tarde");
        });
    },

    newUserDT(){
      let data_form;
      data_form = {
        user_id: `${this.user_data.id}`,
        email: this.user_data.email,
        first_name: this.user_data.first_name,
        last_name: this.user_data.last_name,
        username: this.user_data.email,
        phone: this.user_data.phone,
        nationality: this.user_data.country ? this.user_data.country.name : "Venezuela",
        country_of_residence: this.user_data.country ? this.user_data.country.name : "Venezuela",
      };
      let form = {
        data: data_form,
      };

      this.UserCreateDT(form)
        .then((response) => {
            this.deleting = false;
            console.log(response);
            Swal.fire({
              title: "¡Bienvenid@ a Pizarra DT!",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            });
            window.open('https://app.lapizarradeldt.com/auth/fvf?token=Bearer ' + response.token, '_blank');
        })
        .catch((error) => {
          console.log(error);
          this.deleting = false;
          alert("Ocurrió un error, intente más tarde");
        });
    },

    openModalPayment() {
      console.log(this.form_update);
      this.bcvRate.value = parseFloat(this.bcvRate.value).toFixed(2);
      this.bcvRate.value = this.bcvRate.value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      this.totalPaymentAmount = parseFloat(
        this.form_update.amount * this.bcvRate.value
      ).toFixed(2);
      this.totalPaymentAmount = this.totalPaymentAmount.toLocaleString(
        "es-VE",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      );
      console.log("OPEN PAYMENT MODAL");
      setTimeout(() => {
        $("#modalPayment").modal("toggle");
      }, 100); // tiempo en milisegundos
      this.modalActiveUpdate = true;
    },

    closePaymentElement() {
      console.log("CLOSING PAYMENT MODAL");
      $("#modalPayment").modal("toggle");
      this.form_payment = {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
      };
      this.modalActiveUpdate = false;
    },

    savePayment() {
      if (this.form_payment.id_company_bank == "") {
        Swal.fire({
          title: "Seleccione un banco",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.origin_bank == "") {
        Swal.fire({
          title: "Ingrese el banco emisor",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.date == "") {
        Swal.fire({
          title: "Seleccione la fecha del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.phone == "") {
        Swal.fire({
          title: "Ingrese el teléfono del banco emisor",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.amount == 0) {
        Swal.fire({
          title: "Ingrese el monto pagado",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.reference == "") {
        Swal.fire({
          title: "Ingrese la referencia del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else {
        Swal.fire({
          title: "¿Estás seguro de reportar este pago?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Sí, reportar",
        }).then((result) => {
          if (result.value) {
            let data_form;
            data_form = new FormData();
            data_form.append("id_user", this.id_user_logged);
            data_form.append("id_user_platform", this.form_update.id);
            data_form.append(
              "id_company_bank",
              this.form_payment.id_company_bank.id
            );
            data_form.append("id_bcv_rate", this.bcvRate.id);
            data_form.append("reference", this.form_payment.reference);
            data_form.append("origin_bank", this.form_payment.origin_bank);
            data_form.append("amount", this.amountWithDecimals);
            data_form.append(
              "date",
              new Date(this.form_payment.date).toISOString().slice(0, 10)
            );
            data_form.append("phone", this.form_payment.phone);
            const filePondInstance = this.$refs.filePondPayment.getFiles();
            if (filePondInstance && filePondInstance.length > 0) {
              const file = filePondInstance[0].file;
              data_form.append("url_image", file);
            }
            let form = {
              url: "user/payment_report/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.closePaymentElement();
                  Swal.fire({
                    title: "Pago registrado correctamente",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                  location.reload(true);
                }
              })
              .catch((error) => {
                console.log(error);
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }
    },

    disableFutureDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    showList() {
      this.listVisible = true;
    },

    handleOpenChange() {
      console.log("OPEN DATE SELECTOR");
      this.selectorOpen = true;
    },

    handleCloseChange() {
      console.log("CLOSE DATE SELECTOR");
      this.selectorOpen = false;
    },

    uploadFiles() {
      const filePondInstance = this.$refs.filePond.getFiles();
      if (filePondInstance && filePondInstance.length > 0) {
        Swal.fire({
          title: "Subiendo archivos...",
          icon: "info",
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const promises = [];
        for (let i = 0; i < filePondInstance.length; i++) {
          let data_form;
          data_form = new FormData();
          const file = filePondInstance[i].file;
          const fileName = file.name;
          data_form.append("url_file", file);
          data_form.append("name", fileName);
          data_form.append("id_user_platform", this.id_user_platform);
          let form = {
            url: "user_file_platform/save",
            data: data_form,
          };
          promises.push(this.createData(form));
        }

        Promise.all(promises)
          .then((responses) => {
            // Handle success
            this.deleting = false;

            this.closeUploadElement();
            this.$router.push({ name: "Postulation" });
          })
          .catch((error) => {
            console.log(error);
            alert("Ocurrió un error, intente más tarde");
          })
          .finally(() => {
            Swal.close();
            Swal.fire({
              title: "Postulación enviada correctamente",
              text: "Ahora debes esperar a que respondan tu solicitud",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            });
          });
      }
    },

    openUploadElement() {
      console.log("OPEN UPLOAD MODAL");
      setTimeout(() => {
        $("#modalPostulation").modal("toggle");
      }, 100); // tiempo en milisegundos

      this.modalActiveUpdate = true;
    },

    closeUploadElement() {
      console.log("CLOSING UPLOAD MODAL");
      $("#modalPostulation").modal("toggle");
      this.modalActiveUpdate = false;
    },

    loadImage() {
      let image = new Image();
      image.src = this.form_update.url_banner;
      image.onload = () => {
        this.loading = false;
        console.log("Image loaded");
      };
      image.onerror = () => {
        this.loading = false;
        console.log("Image not loaded");
      };
    },

    getElement(id) {
      this.loaded = false;
      let data_params = {
        url: "user/platform/" + id,
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          this.form_update = response.data;

          this.form_update.amount = parseFloat(this.form_update.amount).toFixed(
            2
          );
          this.form_update.amount = this.form_update.amount.toLocaleString(
            "es-VE",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );

          this.loaded = true;
        })
        .catch((error) => {
          this.loaded = true;
          console.log(error);
        });
    },

    getStatus() {
      let data_params = {
        url: "user/user_platform/all",
        params: {
          active: 1,
          // id_user: this.id_user_logged,
          id_platform: this.$route.params.id,
          order_by: "id",
          order_key: "asc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            if (response.data.length > 0) {
              this.id_type_status = response.data[0].id_type_status;
              this.id_type_status_payment =
                response.data[0].id_type_status_payment;
              this.id_user_platform = response.data[0].id;
              this.loadUserFiles(this.id_user_platform);
              if (this.id_type_status == 3) {
                this.loadBcvRate();
                this.loadCompanyBank();
              }
            } else {
              this.id_type_status = 0;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadBcvRate() {
      let data_params = {
        url: "bcv_rate/all",
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.bcvRate = response.data[0];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCompanyBank() {
      let data_params = {
        url: "user/company_bank/all",
        params: {
          active: 1,
          order_by: "id",
          order_key: "asc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.companyBank = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadUserFiles(id_user_platform) {
      if (this.id_type_status != 3) {
        let data_params = {
          url: "user_file_platform/all",
          params: {
            active: 1,
            id_user_platform: id_user_platform,
            order_by: "id",
            order_key: "asc",
          },
        };

        this.getData(data_params)

          .then((response) => {
            if (response.code == 200) {
              this.filesUser = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    deleteFile(id) {
      Swal.fire({
        title: "¿Estás seguro de eliminar este archivo?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#048224ff",
        cancelButtonColor: "#abb2ba",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar",
      }).then((result) => {
        if (result.value) {
          let data_form;
          data_form = {
            active: 2,
          };
          let form = {
            url: "user_file_platform/update",
            id: id,
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserFiles(this.id_user_platform);
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
            });
        }
      });
    },

    returnUrl() {
      this.$router.go(-1);
    },

    postulateWithRequires() {
      if (this.form_update.autoapproved == 0) {
        Swal.fire({
          title: "¡Atención!",
          text: "¿Estás seguro de postularte a " + this.form_update.name + "?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#048224ff",
          cancelButtonColor: "#abb2ba",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Sí, postularme",
        }).then((result) => {
          if (result.value) {
            let data_form;

            data_form = {
              id_user: this.id_user_logged,
              id_platform: this.form_update.id,
              id_type_status: 1,
              id_type_status_payment: 1,
            };

            this.deleting = true;
            let form = {
              url: "user/user_platform/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.id_user_platform = response.data.id;
                  console.log(response.data);
                  const filePondInstance = this.$refs.filePond.getFiles();
                  if (filePondInstance && filePondInstance.length > 0) {
                    this.uploadFiles();
                  } else {
                    Swal.fire({
                      title: "Postulación enviada correctamente",
                      text: "Ahora debes esperar a que respondan tu solicitud",
                      icon: "success",
                      showConfirmButton: true,
                      showLoaderOnConfirm: true,
                    });
                    this.closeUploadElement();
                    this.$router.push({ name: "Postulation" });
                  }
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }
    },

    postulateMe() {
      if (this.form_update.autoapproved == 0) {
        Swal.fire({
          title: "¡Atención!",
          text: "¿Estás seguro de postularte a " + this.form_update.name + "?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, continuar",
        }).then((result) => {
          if (result.value) {
            let data_form;

            data_form = {
              id_user: this.id_user_logged,
              id_platform: this.form_update.id,
              id_type_status: 1,
              id_type_status_payment: 1,
            };

            this.deleting = true;
            let form = {
              url: "user/user_platform/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Postulación enviada correctamente",
                    text: "Ahora debes esperar a que respondan tu solicitud",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });

                  this.$router.push({ name: "Overview" });
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }

      if (this.form_update.autoapproved == 1) {
        let data_form;

        data_form = {
          id_user: this.id_user_logged,
          id_platform: this.form_update.id,
          id_type_status: 3,
          id_type_status_payment: 3,
        };

        this.deleting = true;
        let form = {
          // url: "user_platform/save",
          url: "user/user_platform/save",
          data: data_form,
        };
        this.createData(form)
          .then((response) => {
            if (response.code === 200) {
              this.deleting = false;
              Swal.fire({
                title: "¡Bienvenido al curso!",
                text: "Ahora puedes acceder al curso",
                icon: "success",
                showConfirmButton: false,
                showLoaderOnConfirm: true,
                timer: 1000,
              });

              this.$router.push({ name: "Overview" });
            }
          })
          .catch((error) => {
            console.log(error);
            this.deleting = false;
            alert("Ocurrió un error, intente más tarde");
          });
      }
    },
  },
};
</script>

<style>
.loader {
  display: flex;
  justify-content: center;
  height: 300px;
}

.loader-icon {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.datepicker-container {
  width: 100%;
}

input.mx-input {
  border: none;
}

.form-control:hover {
  box-shadow: #b49b57;
  border-color: #b49b57;
}
.filepond--drop-label {
  height: 148px !important;
}
.filepond--drop-label.filepond--drop-label label {
  margin-top: 100px;
  text-align: center !important;
  color: black !important;
  font-size: small;
}
</style>
<style scoped>
/* Define la altura máxima y permite el desplazamiento */
.scrollable {
  max-height: 400px;
  overflow-y: auto;
}
.user-header {
  font-weight: bold;
  font-size: 15.6px;
}
.user-row {
  font-size: 15.6px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
